import { isEmpty } from 'lodash';
import {
    validateError,
    ErrorAPICode,
    ErrorAPIReasons,
    ErrorAPIMessages,
    ErrorAPIErrors,
    errorMap,
} from '../../error/error_map';

const errorReasons = { ...ErrorAPIReasons };
const errorCodes = { ...ErrorAPICode };
const errorMessages = { ...ErrorAPIMessages };

const errorErrors = {
    ...ErrorAPIErrors,
    TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
};


const customErrorMap = {
    ...errorMap,

    TOO_MANY_REQUESTS: (err) => {
        return {
            title: 'Too many requests',
            message: err.message,
            text: err.message,
        }
    }
};

export function serviceErrorSerializer (errors) {
    if (isEmpty(errors)) {
        return {};
    }
    const options = {
        errorMap: customErrorMap,
        reasons: errorReasons,
        codes: errorCodes,
        messages: errorMessages,
        errors: errorErrors,
    };
    const error = validateError(errors[0], options);
    return error;
}
